import { useState } from 'react';
import { Form, Button, PageHeader, Popconfirm } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';

import { commonVerticalLayout } from '../../../constants/formLayout';
import { apiService, notificationService, userService } from '../../../services';
import { Spinner } from '../../../components/Spinner';
import { Pages } from '../../../1_shared/constants/pages';
import { CategoryTabs } from '../../../components/Tabs/CategoryTabs';
import { dictionaries } from '../../../dictionaries';
import { useFetchData } from '../../../hooks/useFetchData';
import { ACL } from '../../../components/ACL';
import { Permissions } from '../../../enums/permissions';

export const CategoryEditPage = () => {
  const navigate = useNavigate();
  const param: any = useParams();
  const [form] = Form.useForm();

  const { isLoading: isDataLoading, data = {} } = useFetchData(`/product-categories/${param.id}`);
  const [isSaveBtnDisabled, setSaveBtnDisabled]: any = useState(false);

  const isNew = !param.id;

  const subTitle = isNew ? 'Создание категории' : 'Редактирование категории';

  if (!isNew && isDataLoading) {
    return <Spinner />;
  }

  const handleCancel = () => {
    navigate(Pages.TYPES);
  };

  const handleSave = async () => {
    try {
      setSaveBtnDisabled(true);

      await form.validateFields();
      const body = form.getFieldsValue();

      if (isNew) {
        const requestedData = await apiService.POST('/product-categories', body);

        navigate(`${Pages.CATEGORIES}/${requestedData.id}`);
      } else {
        await apiService.PATCH(`/product-categories/${data.id}`, body);
      }
      notificationService.notifySuccess('Категория товара успешно сохранена');
      dictionaries.protuctTypesDictionary.fetch();
    } catch (error) {
      notificationService.notifyError(error);
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  const handleDelete = async () => {
    try {
      setSaveBtnDisabled(true);
      await apiService.DELETE(`/product-categories/${data.id}`);
      navigate(Pages.TYPES);
      notificationService.notifySuccess('Категория успешно удалена');
      dictionaries.protuctTypesDictionary.fetch();
    } catch (error) {
      notificationService.notifyError(error);
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  return (
    <ACL roles={[Permissions.SUPER_ADMIN, Permissions.ADMIN]}>
      <>
        <PageHeader
          className="page-header"
          title="Категория"
          subTitle={subTitle}
          extra={[
            <Popconfirm
              key='delete-btn'
              title="Вы действительно хотите удалить услугу?"
              onConfirm={handleDelete}
              disabled={isNew || !userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN])}
              okText="Да"
              cancelText="Нет"
            >
              <Button
                disabled={isNew || !userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN])}
                danger>
                Удалить
              </Button>
            </Popconfirm>,
            <Button key="2" onClick={handleCancel}>
              {isNew ? 'Отмена' : 'Закрыть'}
            </Button>,
            <Button
              key="1"
              type="primary"
              disabled={isSaveBtnDisabled}
              onClick={handleSave}
            >
              Сохранить
            </Button>,
          ]}
        />
        <div className='page-content'>
          <Form
            className="mg-t-16"
            form={form}
            labelAlign="left"
            requiredMark={false}
            initialValues={data}
            layout="vertical"
            {...commonVerticalLayout}
          >
            <CategoryTabs generalTabProps={{ data, form }} />
          </Form>
        </div>
      </>
    </ACL>
  );
};
